export default "__VITE_ASSET__Hsyu2Nko__"